import Game from './TicTacToe/Game'
import Home from './home'
import Valentine from './Valentine/Valentine'
import Location from './Location/Location'
import DataScience from './DataScience/DataScience'
import Testcomp from './Testcomp/Testcomp'
import LoginComponent from './Login/LoginComponent'
import PeopleGraph from './peopleGraph/PeopleGraph'

import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/tictactoe" element={<Game />} />
        <Route path="/valentine" element={<Valentine />} />
        <Route path="/location" element={<Location />} />
        <Route path="/ds" element={<DataScience />} />
        <Route path="/tc" element={<Testcomp />} />
        <Route path="/login" element={<LoginComponent />} />
        <Route path="/pg" element={<PeopleGraph />} />

      </Routes>
    </Router>
  );
}

export default App;
